import {
  SET_CUSTOMER_INFORMATION,
  CLEAR_CUSTOMER_INFORMATION,
  SET_ACTIVE_FORM,
  SET_IS_SAME,
  SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES,
  SET_TLDS_WITH_SEPARATE_PAGE_TERMS,
  SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS,
  SET_CITIZENSHIP_COUNTRY_CODE,
} from "../constants";

import { qualifySelector } from "../utils";

const initialState = {
  activeForm: "customer",
  isSame: true,
  marketingCommunication:
    (window.localStorage.getItem("customerInformation") &&
      JSON.parse(window.localStorage.getItem("customerInformation"))
        .marketingCommunication) ||
    "UNCHECKED",
  customer: null,
  registrant: null,
  customerCitizenshipCountry: window.sessionStorage.getItem(
    "customerCitizenshipCountry",
  ),
  tldsWithSeparateTermsPage: [],
  tldsWithSpecialRegistryTerms: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_CUSTOMER_INFORMATION:
      const { formType, fieldValue, fieldName } = action.payload;
      return {
        ...state,
        [formType]: {
          ...state[formType],
          [fieldName]: fieldValue,
        },
      };
    case SET_ACTIVE_FORM:
      return {
        ...state,
        activeForm: action.payload,
      };
    case SET_IS_SAME:
      return {
        ...state,
        isSame: action.payload,
      };
    case SUBSCRIBE_TO_NEWSLETTER_AND_PREFERENCES:
      return {
        ...state,
        marketingCommunication: action.payload,
      };
    case CLEAR_CUSTOMER_INFORMATION:
      return {
        ...initialState,
      };
    case SET_TLDS_WITH_SEPARATE_PAGE_TERMS:
      return {
        ...state,
        tldsWithSeparateTermsPage: action.payload,
      };
    case SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS:
      return {
        ...state,
        tldsWithSpecialRegistryTerms: action.payload,
      };
    case SET_CITIZENSHIP_COUNTRY_CODE:
      return {
        ...state,
        customerCitizenshipCountry: action.payload,
      };
    default:
      return state;
  }
}

export const name = "customerInformation";
export default { [name]: reducer };

export const getCustomerInformationFromLocalStorage = qualifySelector(
  name,
  (state) => {
    const retrievedData = window.localStorage.getItem("customerInformation");

    return JSON.parse(retrievedData);
  },
);

export const getActiveFormFromLocalStorage = qualifySelector(name, (state) => {
  const retrievedData = window.localStorage.getItem("customerInformation");

  return (
    (JSON.parse(retrievedData) && JSON.parse(retrievedData).activeForm) ||
    "customer"
  );
});

export const getIsRegistrantFromLocalStorage = qualifySelector(
  name,
  (state) => {
    const retrievedData = JSON.parse(
      window.localStorage.getItem("customerInformation"),
    );
    return retrievedData && retrievedData.isSame !== undefined
      ? retrievedData.isSame
      : true;
  },
);

export const getTldsWithSeparateTermsPage = qualifySelector(
  name,
  (state) => state.tldsWithSeparateTermsPage,
);

export const getTldsWithSpecialRegistryTerms = qualifySelector(
  name,
  (state) => state.tldsWithSpecialRegistryTerms,
);

export const getCustomerType = qualifySelector(
  name,
  (state) => (state.customer && state.customer.type) || "private",
);

export const getMarketingPreferences = qualifySelector(
  name,
  (state) => state.marketingCommunication,
);

export const getCitizenshipCountryFromSession = qualifySelector(
  name,
  (state) => state.customerCitizenshipCountry || null,
);
